module.exports = __webpack_public_path__ + "img/icon81.4aefd456.png";